const getConfig = (root, kind = 'config') => {
    const selector = `script[data-kind="${kind}"][type="application/json"]`;
    return [...root.querySelectorAll(selector)].map((script) => JSON.parse(script.textContent));
};

const paymentType = 'paypal:applepay';

Alpine.data('SevenPaymentPaypalApplePay', (element) => ({
    isSupported: false,
    instance: null,
    sdk: null,

    config: getConfig(element).at(-1),

    paypalApplePay: null,
    paypalApplePayConfig: null,

    model: {
        total: {},
    }, // @see https://developer.apple.com/documentation/apple_pay_on_the_web/applepaypaymentrequest

    async init() {
        this.instance = await new Promise((resolve) => {
            document.addEventListener('seven:payment:paypal:client:init', (event) => resolve(event.detail));
        });

        if (!window.ApplePaySession?.canMakePayments()) {
            return;
        }

        this.paypalApplePay = this.instance.paypal.Applepay();
        this.paypalApplePayConfig = await this.paypalApplePay.config();

        if (this.paypalApplePayConfig.isEligible) {
            this.isSupported = true;
        }
    },

    async submit(e) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();

        const { session } = await this._createApplePaySession();
        if (this._dispatchEvent(`sessioncreated`, { id: this.config.id, session })) {
            session.begin();
        }
    },

    async _createApplePaySession() {
        if (this.config.amount && this.config.label && this.config.id) {
            this.model.total.label = this.config.label;
            this.model.total.amount = String(this.config.amount / 100);
            this.model.lineItems = [{
                label: this.config.label,
                amount: String(this.config.amount / 100),
                type: 'final',
            }];
        }

        // @see https://developer.apple.com/documentation/apple_pay_on_the_web/applepaypaymentrequest
        const { session, paymentRequest } = await new Promise((resolve, reject) => {
            const paymentRequest = {
                countryCode: this.paypalApplePayConfig.countryCode,
                merchantCapabilities: this.paypalApplePayConfig.merchantCapabilities,
                supportedNetworks: this.paypalApplePayConfig.supportedNetworks,
                currencyCode: this.config.currency,
                // requiredShippingContactFields: ['postalAddress', 'phone', 'email'],
                requiredBillingContactFields: ['postalAddress'],
                ...(this.model ?? {}),
            };

            if (this._dispatchEvent(`createsession`, {
                id: this.config.id,
                instance: this.instance,
                paymentRequest,
                completeCreateSession: resolve,
            })) {
                resolve({
                    session: new ApplePaySession(4, paymentRequest),
                    paymentRequest,
                });
            }
        });

        // session.onshippingcontactselected = (event) => {
        //     const complete = this._dispatchEvent(`shippingcontactselected`, {
        //         session,
        //         paymentRequest,
        //         id: this.config.id,
        //         shippingContact: event.shippingContact,
        //     });
        //
        //     if (complete) {
        //         session.completeShippingContactSelection({
        //             newTotal: paymentRequest.total,
        //         });
        //     }
        // };

        // session.oncouponcodechanged = (event) => {
        //     const complete = this._dispatchEvent(`couponcodechanged`, {
        //         session,
        //         paymentRequest,
        //         id: this.config.id,
        //         couponCode: event.couponCode,
        //     });
        //
        //     if (complete) {
        //         session.completeCouponCodeChange({
        //             newTotal: paymentRequest.total,
        //         });
        //     }
        // };

        session.onvalidatemerchant = async (event) => {
            try {
                const result = await this.paypalApplePay.validateMerchant({
                    validationUrl: event.validationURL,
                    displayName: this.config.storeName,
                });

                session.completeMerchantValidation(result.merchantSession);
            } catch (validationErr) {
                // @todo show an error to the user, e.g. 'Apple Pay failed to load.'
                console.error('Error validating merchant:', validationErr);
                try {
                    session.abort();
                } catch (e) {

                }
            }
        };

        session.onpaymentauthorized = async (event) => {
            this._dispatchEvent(`paymentauthorized`, { ...event.payment });

            const {
                token,
                redirectUrl,
                salesTax,
            } = await this.instance.createOrder(this.config.id, this.config.productIdentifier);

            try {
                await this.paypalApplePay.confirmOrder({
                    orderId: token,
                    token: event.payment.token,
                    billingContact: event.payment.billingContact,
                });

                session.completePayment(ApplePaySession.STATUS_SUCCESS);
                this._dispatchEvent(`paymentcompleted`, { ...event.payment });
                window.location.href = redirectUrl;
            } catch (e) {
                console.dir(e);
                console.dir(JSON.parse(JSON.stringify(e)));
                session.completePayment(ApplePaySession.STATUS_FAILURE);
            }
        };

        return { session, paymentRequest };
    },

    _dispatchEvent(name, { cancelable, bubbles, ...detail } = {}) {
        return element.dispatchEvent(new CustomEvent(`seven:payment:paypal:applepay:${name}`, {
            detail,
            bubbles: bubbles ?? true,
            cancelable: cancelable ?? true,
        }));
    },
}));


